var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",style:({height:_vm.height}),attrs:{"fluid":""}},[_c('iframe',{attrs:{"src":_vm.iframeSrc,"frameborder":"0","height":"100%","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }